import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import Sprite from './Sprite.js';
import { getOSM } from '../OverworldAnimation.js';
import { formatMinutesAsTime } from '../utilities.js';
import { GAME_VERSION } from '../constants.js';
import PixelText from './PixelText.js';

export default class TrainerCard extends Drawable {
    constructor({ visible = false, position = { x: 0, y: 0 }, stateMachine }) {
        super();
        this.visible = visible;
        this.position = position;
        this.stateMachine = stateMachine;

        this.sprites = {
            background: new Sprite({
                position: this.position,
                image: imageStore.get(`img/trainer_card_${this.stateMachine.player.gender}.png`),
                visible: true,
            }),
        };

        this.trainerIDText = new PixelText({
            text: `IDNo.${this.stateMachine.player.id}`,
            position: { x: this.position.x + 158, y: this.position.y + 28 - 7 },
            color: 'black',
        });

        this.trainerNameText = new PixelText({
            text: `Name: ${this.stateMachine.player.name}`,
            position: { x: 29, y: 48 - 7 },
            color: 'black',
        });

        this.gameVersionText = new PixelText({
            text: `v${GAME_VERSION}`,
            position: { x: 150, y: 48 - 7 },
            textAlign: 'right',
            color: 'black',
        });

        this.moneyLabelText = new PixelText({
            text: 'Money',
            position: { x: 29, y: 75 - 7 },
            color: 'black',
        });
        this.moneyAmountText = new PixelText({
            text: `\u20BD${this.stateMachine.player.money}`,
            position: { x: 150, y: 75 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.pokedexLabelText = new PixelText({
            text: 'Pokedex',
            position: { x: 29, y: 91 - 7 },
            color: 'black',
        });
        this.pokedexCountText = new PixelText({
            text: `${this.stateMachine.player.pokedex.caught.length}`, // TODO: Implement
            position: { x: 150, y: 91 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.timeLabelText = new PixelText({
            text: 'Time',
            position: { x: 29, y: 108 - 7 },
            color: 'black',
        });
        this.timeCountText = new PixelText({
            text: '00:00',
            position: { x: 150, y: 108 - 7 },
            color: 'black',
            textAlign: 'right',
        });
    }

    draw() {
        if (this.stateMachine !== getOSM()) {
            this.stateMachine = getOSM();
        }
        if (!this.visible) {
            return;
        }

        this.timeCountText.text = formatMinutesAsTime(getOSM().totalTimePlayed);

        this.sprites.background.draw();
        this.trainerIDText.draw();
        this.trainerNameText.text = `Name: ${this.stateMachine.player.name}`;
        this.trainerNameText.draw();
        this.gameVersionText.draw();

        this.moneyLabelText.draw();
        this.moneyAmountText.text = `\u20BD${this.stateMachine.player.money}`;
        this.moneyAmountText.draw();

        this.pokedexLabelText.draw();
        this.pokedexCountText.text = `${
            Object.values(this.stateMachine.player.pokedex.caught).filter((p) => p !== null).length
        }`;
        this.pokedexCountText.draw();
        this.timeLabelText.draw();
        this.timeCountText.draw();
    }
}
